import * as React from 'react';

export const LazyLiquidityNOKExclusion = React.lazy(() => import('./component'));
